import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { OrchestrationQuery, OrchestrationState, OrchestrationStore } from '../../state';

@Injectable({ providedIn: 'root' })
export class OrchestrationUserDataService extends AbstractUserRelatedDataService<OrchestrationState> {
  constructor(readonly http: HttpClient, readonly store: OrchestrationStore, readonly query: OrchestrationQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'dags-lastseen',
        starred: 'dags-starred',
      },
    });
  }
}
